// ==========================================
// DashboardPage.jsx
// ==========================================

import React, { useState, useEffect } from "react";
import AppLayout from "../components/layout/AppLayout";
import CourseCard from "../components/dashboard/CourseCard";
import api from "../api/api";
import Spinner from "../components/common/Spinner";

function DashboardPage() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔒 Carrega SOMENTE cursos adquiridos pelo usuário
  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get("/courses/my");
        setCourses(res.data.courses || []);
      } catch (err) {
        console.error("Erro ao carregar cursos do dashboard:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  if (loading) {
    return (
      <AppLayout>
        <div className="min-h-screen flex justify-center items-center bg-slate-950 p-10">
          <Spinner />
        </div>
      </AppLayout>
    );
  }

// Filtros corrigidos para garantir tipagem numérica
const inProgress = courses.filter((c) => {
  const p = Number(c.progress) || 0;
  return p > 0 && p < 100;
});

const newCourses = courses.filter((c) => {
  const p = Number(c.progress) || 0;
  return p === 0;
});

const completed = courses.filter((c) => {
  const p = Number(c.progress) || 0;
  return p >= 100;
});

  return (
    <AppLayout>
      <div className="p-8 w-full min-h-screen bg-slate-950 text-slate-50">

        {/* Título */}
        <h1 className="text-4xl font-extrabold text-indigo-400 mb-8 tracking-wide drop-shadow-[0_0_8px_rgba(129,140,248,0.6)]">
          📚 Meu Dashboard
        </h1>

        {/* ================= Cursos em andamento ================= */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-indigo-300 mb-5 border-b border-slate-800 pb-2">
            Cursos em Andamento ({inProgress.length})
          </h2>

          {inProgress.length === 0 && (
            <p className="text-slate-500 italic">
              Você não possui cursos em andamento.
            </p>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {inProgress.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        </section>

        {/* ================= Novos cursos ================= */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-slate-300 mb-5 border-b border-slate-800 pb-2">
            Cursos Iniciados ({newCourses.length})
          </h2>

          {newCourses.length === 0 && (
            <p className="text-slate-500 italic">
              Nenhum curso novo para iniciar.
            </p>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {newCourses.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        </section>

        {/* ================= Concluídos ================= */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-emerald-300 mb-5 border-b border-slate-800 pb-2">
            Cursos Concluídos ({completed.length})
          </h2>

          {completed.length === 0 && (
            <p className="text-slate-500 italic">
              Nenhum curso concluído ainda.
            </p>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {completed.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        </section>

      </div>
    </AppLayout>
  );
}

export default DashboardPage;
